import { useState, useEffect } from "react";
import api from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Bell, Check, CheckCheck } from "lucide-react";

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => { fetchNotifications(); }, []);

  const fetchNotifications = async () => {
    try {
      const res = await api.get("/notifications");
      setNotifications(res.data.items || []);
      setUnreadCount(res.data.unread_count || 0);
    } catch { /* ignore */ }
  };

  const markRead = async (id) => {
    try { await api.put(`/notifications/${id}/read`); fetchNotifications(); } catch { /* ignore */ }
  };

  const markAllRead = async () => {
    try { await api.put("/notifications/read-all"); fetchNotifications(); } catch { /* ignore */ }
  };

  return (
    <div data-testid="notifications-page" className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight" style={{ fontFamily: "Chivo, sans-serif" }}>Notifications</h1>
          <p className="text-sm text-gray-500 mt-1">{unreadCount} unread</p>
        </div>
        {unreadCount > 0 && (
          <Button data-testid="mark-all-read" variant="outline" onClick={markAllRead} className="rounded-sm">
            <CheckCheck size={14} className="mr-1.5" /> Mark All Read
          </Button>
        )}
      </div>

      <div className="space-y-2">
        {notifications.length === 0 && (
          <Card className="border border-gray-200 rounded-sm"><CardContent className="p-8 text-center">
            <Bell size={32} className="mx-auto text-gray-300 mb-2" />
            <p className="text-sm text-gray-400">No notifications yet</p>
          </CardContent></Card>
        )}
        {notifications.map((n) => (
          <Card key={n.id} data-testid={`notification-${n.id}`} className={`border rounded-sm ${n.read ? "border-gray-200 bg-white" : "border-[#0052CC]/30 bg-blue-50/30"}`}>
            <CardContent className="p-4 flex items-center justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <span className={`text-sm font-medium ${n.read ? "text-gray-700" : "text-[#09090B]"}`}>{n.title}</span>
                  {!n.read && <span className="w-2 h-2 rounded-full bg-[#0052CC]" />}
                </div>
                {n.message && <p className="text-xs text-gray-500 mt-1">{n.message}</p>}
                <div className="text-[10px] text-gray-400 mt-1">{n.created_at ? new Date(n.created_at).toLocaleString() : ""}</div>
              </div>
              {!n.read && (
                <Button variant="ghost" size="sm" onClick={() => markRead(n.id)} className="h-7 px-2">
                  <Check size={14} />
                </Button>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
